import { API_BASIC_URL } from '@/constants'
import { IFormDataOvertimePolicy } from '@/pages/overtime/overtime-policy/create/yup-validation'
import { IFormDataOvertimeSetting } from '@/pages/overtime/overtime-policy/index/yup-validation'
import { IOvertimePolicy, IPaginationParam, IPaginationResponse } from '@/types'
import { createAxiosInstance } from '@/utils'
import { GenericAbortSignal } from 'axios'

const axiosBasic = createAxiosInstance({ baseURL: API_BASIC_URL, withAuth: true })

export const fetchOvertimePolicies = (params?: IPaginationParam, signal?: GenericAbortSignal) => {
  return axiosBasic
    .get<{ data: IPaginationResponse<IOvertimePolicy> }>(`/overtime-policy`, { params, signal })
    .then((response) => response.data.data)
}

export const createOvertimePolicy = (payload: IFormDataOvertimePolicy) => {
  return axiosBasic.post<{ data: IFormDataOvertimePolicy }>(`/overtime-policy`, payload).then((response) => response.data.data)
}

export const updateOvertimePolicy = (id: string, payload: IFormDataOvertimePolicy) => {
  return axiosBasic.put<{ data: IFormDataOvertimePolicy }>(`/overtime-policy/${id}`, payload).then((response) => response.data.data)
}

export const deleteOvertimePolicy = (id: string) => {
  return axiosBasic.delete(`/overtime-policy/${id}`).then((response) => response.data.data)
}

export const fetchOvertimePolicy = (id: string) => {
  return axiosBasic.get(`/overtime-policy/${id}`).then((response) => response.data.data)
}

export const fetchOvertimeSettings = () => {
  return axiosBasic.get('/overtime-setting').then((response) => response.data.data)
}

export const updateOvertimeSettings = (payload: IFormDataOvertimeSetting) => {
  return axiosBasic.put<{ data: IFormDataOvertimeSetting }>('/overtime-setting', payload).then((response) => response.data.data)
}

export const downloadOvertimePolicy = () => {
  return axiosBasic
    .get(`/overtime-policy/export`, {
      responseType: 'blob',
      headers: {
        Accept: 'application/octet-stream',
      },
    })
    .then((response) => {
      return response
    })
}
